import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import SurveysPDF from '../../assets/White_Paper_Survey.pdf'
import VoicePDF from '../../assets/Whistle_Volara_Co-Marketing_Flyer.pdf'

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 1rem;
`
const Icon = css`
  font-size: 2rem !important;
  color: #FBBD08;
  margin-bottom: .5rem;
  margin-top: 1rem !important;

  @media (min-width: 767px) {
    font-size: 4rem !important;
    margin-top: 1.5rem !important;    
  }
`

const FeaturedIconClass = css`
  ${Icon}
`

const IconWithLink = css`
  transition: .25s ease-out;
  opacity: 1;
  position: relative;
  left: -1rem;

  @media (min-width: 767px) {
    left: -2rem;
  }
`

const FeaturedIconLinkClass = css`
  opacity: 0;
  transform: translateX(-100px);
  transition: .25s ease-out;
  position: relative;
  left: 1rem;

  @media (min-width: 767px) {
    left: 2rem;
  }
  ${Icon}
`

const FeaturedTitleClass = css`
  opacity: 1;
  transition: .25s ease-out;
`

const FeaturedDescClass = css`
  opacity: 0;
  height: 0;
  transform: translateY(100px);
  transition: .25s ease-out;
  font-size: .8rem;
  
  @media (min-width: 767px) {
    font-size: 1rem;
	}
`

const FeaturedClass = css`
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  background-color: white;
  height: 130px;
  margin: .5rem;
  flex: 1 100px;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  overflow: hidden;
  cursor: default;
  color: #232323;

  &.link {
    cursor: pointer;
  }

  &:hover {
    .${FeaturedIconLinkClass} {
      transform: translateX(0);
      opacity: 1;
    }
    .${IconWithLink} {
      opacity: 0;
      transform: translateX(100px)
    }
    .${FeaturedDescClass} {
      opacity: 1;
      height: auto;
      transform: translateY(0px);
    }
    .${FeaturedTitleClass} {
      opacity: 0;
      height: 0;
      margin: 0;
    }
  }

  @media (min-width: 767px) {
    height: 170px;
    max-width: 186px;
    margin: 1rem;
    flex: 1 140px;
	}
`

const FeatureList = (props) => {
  const features = [
    {
      label: 'Multi-Channel Guest Messaging',
      icon: 'device_hub',
      description: 'Communicate with your guests through the channel they want.'
    },
    { 
      label: 'Team Messaging',
      icon: 'people',
      description: 'Streamline internal communication with direct messages or team messages.'
    },
    { 
      label: 'Website Live Chat',
      icon: 'language',
      description: 'Give your website visitors a convenient way to chat with your team.'
    },
    { 
      label: 'Automated Messaging',
      icon: 'all_inclusive',
      description: 'Take the work out of arrival, mid-stay, and departure messaging!'
    },
    { 
      label: 'PMS & Task Management Integrations',
      icon: 'power',
      description: 'One-click integrations with your favorite PMS & Task Management Tool!',
      link: '#partners'
    },
    { 
      label: 'Guest Surveys',
      icon: 'ballot',
      description: 'Send surveys via messaging, collect and review results instantly.',
      link: SurveysPDF,
      target: "_blank"
    },
    { 
      label: 'Translation',
      icon: 'g_translate',
      description: 'Real-time translation for any guest from any part of the world, or even with your staff!'
    },
    { 
      label: 'Analytics & Reporting',
      icon: 'insert_chart',
      description: 'Robust in-app and email analytics with Sentiment Analysis, Team Activity, and more!'
    },
    { 
      label: 'Machine Learning',
      icon: 'memory',
      description: 'Machine Learning & AI powering your Whistle system for a unique experience.',
      link: 'https://www.trywhistle.com/blog/2019-05-15-conversational-artificial-intelligence-in-hospitality-comes-to-life/',
      target: "_blank"
    },
    { 
      label: 'Voice Enablement',
      icon: 'record_voice_over',
      description: 'Seamless cross-channel guest communication.',
      link: VoicePDF,
      target: "_blank"
    },
    { 
      label: 'Opt-In Engine',
      icon: 'notification_important',
      description: 'Industry leading engine for automated guest consent (opt-in/opt-out).',
      link: 'https://www.hospitalitynet.org/news/4090516.html',
      target: "_blank"
    },{ 
      label: 'Automatic & Suggested Replies',
      icon: 'repeat',
      description: 'Let our system do the work for you!'
    }
  ]
  return (
    <List>
      {features.map(feature => (
        feature.link ? (
          <a className={`${FeaturedClass} link`} key={feature.label} href={feature.link} title="Surveys Case Study" target={feature.target}>
            <i className={`${FeaturedIconLinkClass} material-icons`}>arrow_forward</i>
            <i className={`${FeaturedIconClass} ${IconWithLink} material-icons`}>{feature.icon}</i>
            <h4 className={FeaturedTitleClass}>{feature.label}</h4>
            <div className={FeaturedDescClass}>{feature.description}</div>
          </a>
        ) : (
        <div className={FeaturedClass} key={feature.label}>
          <i className={`${FeaturedIconClass} material-icons`}>{feature.icon}</i>
          <h4 className={FeaturedTitleClass}>{feature.label}</h4>
          <div className={FeaturedDescClass}>{feature.description}</div>
        </div>
        )
      ))}
    </List>
  )
}
 
export default FeatureList;


// WEBPACK FOOTER //
// ./src/components/main/FeatureList.js